"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IntegrationsService", {
    enumerable: true,
    get: function() {
        return IntegrationsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _jobsredis = require("~/modules/jobs/redis/jobs-redis");
const _Jobs = require("~/interface/Jobs");
const _sourcesservice = require("~/services/sources.service");
const _exportImportHelpers = require("~/helpers/exportImportHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let IntegrationsService = class IntegrationsService {
    async integrationGetWithConfig(context, param) {
        const integration = await _models.Integration.get(context, param.integrationId);
        if (!integration) {
            _catchError.NcError.get(context).integrationNotFound(param.integrationId);
        }
        integration.config = await integration.getConnectionConfig();
        if (param.includeSources) {
            await integration.getSources();
        }
        return integration;
    }
    async integrationUpdate(context, param) {
        var _integrationBody_title, _param_req;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/IntegrationReq', param.integration);
        const oldIntegration = await _models.Integration.get(context, param.integrationId);
        const integrationBody = param.integration;
        integrationBody.title = (_integrationBody_title = integrationBody.title) == null ? void 0 : _integrationBody_title.trim();
        const integration = await _models.Integration.updateIntegration(context, param.integrationId, _extends({}, integrationBody, {
            id: param.integrationId
        }));
        // update the cache for the sources which are using this integration
        await this.updateIntegrationSourceConfig({
            integration
        });
        integration.config = undefined;
        this.appHooksService.emit(_nocodbsdk.AppEvents.INTEGRATION_UPDATE, {
            integration,
            req: param.req,
            user: (_param_req = param.req) == null ? void 0 : _param_req.user,
            oldIntegration,
            context: _extends({}, context, {
                base_id: null
            })
        });
        return integration;
    }
    async integrationList(param) {
        var _param_req_user;
        const integrations = await _models.Integration.list({
            userId: (_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id,
            includeDatabaseInfo: param.includeDatabaseInfo,
            type: param.type,
            includeSourceCount: true,
            query: param.query
        });
        return integrations;
    }
    async integrationDelete(context, param) {
        const ncMeta = await _Noco.default.ncMeta.startTransaction();
        try {
            var _param_req;
            const integration = await _models.Integration.get(context, param.integrationId, true, ncMeta);
            if (!integration) {
                _catchError.NcError.get(context).integrationNotFound(param.integrationId);
            }
            // get linked sources
            const sourceListQb = ncMeta.knex(_globals.MetaTable.SOURCES).where({
                fk_integration_id: integration.id
            }).where((qb)=>{
                qb.where('deleted', false).orWhere('deleted', null);
            });
            if (integration.fk_workspace_id) {
                sourceListQb.where('fk_workspace_id', integration.fk_workspace_id);
            }
            const sources = await sourceListQb.select('id', 'base_id');
            if (sources.length > 0 && !param.force) {
                const bases = await Promise.all(sources.map(async (source)=>{
                    return await _models.Base.get({
                        workspace_id: integration.fk_workspace_id,
                        base_id: source.base_id
                    }, source.base_id, ncMeta);
                }));
                _catchError.NcError.get(context).integrationLinkedWithMultiple(bases, sources);
            }
            await integration.delete(ncMeta);
            this.appHooksService.emit(_nocodbsdk.AppEvents.INTEGRATION_DELETE, {
                integration,
                req: param.req,
                user: (_param_req = param.req) == null ? void 0 : _param_req.user,
                context: _extends({}, context, {
                    base_id: null
                })
            });
            await ncMeta.commit();
        } catch (e) {
            await ncMeta.rollback(e);
            if (e instanceof _catchError.NcError || e instanceof _catchError.NcBaseError) throw e;
            this.logger.error('Error deleting integeration', e);
            _catchError.NcError.get(context).internalServerError('Error deleting integeration');
        }
        return true;
    }
    async integrationSoftDelete(context, param) {
        try {
            const integration = await _models.Integration.get(context, param.integrationId);
            if (!integration) {
                _catchError.NcError.get(context).integrationNotFound(param.integrationId);
            }
            const ncMeta = await _Noco.default.ncMeta.startTransaction();
            try {
                var _param_req;
                // get linked sources
                const sourceListQb = ncMeta.knex(_globals.MetaTable.SOURCES).where({
                    fk_integration_id: integration.id
                }).where((qb)=>{
                    qb.where('deleted', false).orWhere('deleted', null);
                });
                if (integration.fk_workspace_id) {
                    sourceListQb.where('fk_workspace_id', integration.fk_workspace_id);
                }
                const sources = await sourceListQb.select('id', 'base_id');
                for (const source of sources){
                    await this.sourcesService.baseSoftDelete({
                        workspace_id: integration.fk_workspace_id,
                        base_id: source.base_id
                    }, {
                        sourceId: source.id
                    }, ncMeta);
                }
                await integration.softDelete(ncMeta);
                this.appHooksService.emit(_nocodbsdk.AppEvents.INTEGRATION_DELETE, {
                    integration,
                    req: param.req,
                    user: (_param_req = param.req) == null ? void 0 : _param_req.user
                });
                await ncMeta.commit();
            } catch (e) {
                await ncMeta.rollback(e);
                if (e instanceof _catchError.NcError || e instanceof _catchError.NcBaseError) throw e;
                this.logger.error('Error  deleting integeration', e);
                _catchError.NcError.get(context).internalServerError('Error deleting integeration');
            }
        } catch (e) {
            if (e instanceof _catchError.NcError || e instanceof _catchError.NcBaseError) throw e;
            this.logger.error('Error  deleting integeration', e);
            _catchError.NcError.get(context).internalServerError('Error deleting integeration');
        }
        return true;
    }
    async integrationCreate(context, param) {
        var _integrationBody_title, _param_req;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/IntegrationReq', param.integration);
        let integrationBody;
        if (param.integration.copy_from_id) {
            integrationBody = await _models.Integration.get(context, param.integration.copy_from_id);
            if (!(integrationBody == null ? void 0 : integrationBody.id)) {
                _catchError.NcError.get(context).integrationNotFound(param.integration.copy_from_id);
            }
            integrationBody.config = await integrationBody.getConnectionConfig();
        } else {
            integrationBody = param.integration;
        }
        param.logger == null ? void 0 : param.logger.call(param, 'Creating the integration');
        integrationBody.title = (_integrationBody_title = integrationBody.title) == null ? void 0 : _integrationBody_title.trim();
        // for SQLite check for existing integration which refers to the same file
        if (integrationBody.sub_type === 'sqlite3') {
            var _param_req_user;
            // get all integrations of type sqlite3
            const integrations = await _models.Integration.list({
                userId: (_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id,
                includeDatabaseInfo: true,
                type: _nocodbsdk.IntegrationsType.Database,
                sub_type: _nocodbsdk.ClientType.SQLITE,
                includeSourceCount: false,
                query: ''
            });
            if (integrations.list && integrations.list.length > 0) {
                for (const integration of integrations.list){
                    var _config_connection, _config_connection_connection, _config_connection1, _integrationBody_config_connection, _integrationBody_config, _integrationBody_config_connection_connection, _integrationBody_config_connection1, _integrationBody_config1;
                    const config = integration.config;
                    if (((config == null ? void 0 : (_config_connection = config.connection) == null ? void 0 : _config_connection.filename) || (config == null ? void 0 : (_config_connection1 = config.connection) == null ? void 0 : (_config_connection_connection = _config_connection1.connection) == null ? void 0 : _config_connection_connection.filename)) === (((_integrationBody_config = integrationBody.config) == null ? void 0 : (_integrationBody_config_connection = _integrationBody_config.connection) == null ? void 0 : _integrationBody_config_connection.filename) || ((_integrationBody_config1 = integrationBody.config) == null ? void 0 : (_integrationBody_config_connection1 = _integrationBody_config1.connection) == null ? void 0 : (_integrationBody_config_connection_connection = _integrationBody_config_connection1.connection) == null ? void 0 : _integrationBody_config_connection_connection.filename))) {
                        _catchError.NcError.get(context).badRequest('Integration with same file already exists');
                    }
                }
            }
        }
        let uniqueTitle = '';
        if (param.integration.copy_from_id) {
            var _param_req_user1;
            const integrations = (await _models.Integration.list({
                userId: (_param_req_user1 = param.req.user) == null ? void 0 : _param_req_user1.id,
                includeSourceCount: false,
                query: ''
            })).list || [];
            uniqueTitle = (0, _exportImportHelpers.generateUniqueName)(`${integrationBody.title} copy`, integrations.map((p)=>p.title));
        }
        const integration = await _models.Integration.createIntegration(_extends({}, integrationBody, param.integration.copy_from_id ? {
            title: uniqueTitle
        } : {}, {
            workspaceId: context.workspace_id,
            created_by: param.req.user.id
        }));
        integration.config = undefined;
        this.appHooksService.emit(_nocodbsdk.AppEvents.INTEGRATION_CREATE, {
            integration,
            req: param.req,
            user: (_param_req = param.req) == null ? void 0 : _param_req.user,
            context: _extends({}, context, {
                base_id: null
            })
        });
        return integration;
    }
    async integrationStore(context, integration, payload) {
        if (payload.op === 'list') {
            return await integration.storeList(context, payload.limit, payload.offset);
        } else if (payload.op === 'sum') {
            return await integration.storeSum(context, payload.fields);
        } else if (payload.op === 'get') {
            return await integration.storeGetLatest(context);
        }
    }
    // function to update all the integration source config which are using this integration
    // we are overwriting the source config with the new integration config excluding database name and schema name
    async updateIntegrationSourceConfig({ integration }, ncMeta = _Noco.default.ncMeta) {
        // get all the bases which are using this integration
        const sources = await ncMeta.metaList2(integration.fk_workspace_id, _globals.RootScopes.WORKSPACE, _globals.MetaTable.SOURCES, {
            condition: {
                fk_integration_id: integration.id
            },
            xcCondition: {
                _or: [
                    {
                        deleted: {
                            eq: false
                        }
                    },
                    {
                        deleted: {
                            eq: null
                        }
                    }
                ]
            }
        });
        // iterate and update the cache for the sources
        for (const sourceObj of sources){
            const source = new _models.Source(sourceObj);
            // update the cache with the new config(encrypted)
            await _NocoCache.default.update({
                workspace_id: source.fk_workspace_id,
                base_id: source.base_id
            }, `${_globals.CacheScope.SOURCE}:${source.id}`, {
                integration_config: integration.config
            });
            // delete the connection ref
            await _NcConnectionMgrv2.default.deleteAwait(source);
            // release the connections from the worker
            if (_jobsredis.JobsRedis.available) {
                await _jobsredis.JobsRedis.emitWorkerCommand(_Jobs.InstanceCommands.RELEASE, source.id);
                await _jobsredis.JobsRedis.emitPrimaryCommand(_Jobs.InstanceCommands.RELEASE, source.id);
            }
        }
    }
    async callIntegrationEndpoint(context, params) {
        var _integrationMeta_expose;
        const integration = await _models.Integration.get(context, params.integrationId);
        const integrationMeta = integration.getIntegrationMeta();
        const wrapper = integration.getIntegrationWrapper();
        if (!integrationMeta || !wrapper) {
            _catchError.NcError.get(context).badRequest('Invalid integration');
        }
        if (!((_integrationMeta_expose = integrationMeta.expose) == null ? void 0 : _integrationMeta_expose.includes(params.endpoint)) || !(params.endpoint in wrapper) || typeof wrapper[params.endpoint] !== 'function') {
            _catchError.NcError.get(context).genericNotFound('Endpoint', params.endpoint);
        }
        return wrapper[params.endpoint](params.payload);
    }
    constructor(appHooksService, sourcesService){
        this.appHooksService = appHooksService;
        this.sourcesService = sourcesService;
        this.logger = new _common.Logger(IntegrationsService.name);
    }
};
IntegrationsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _sourcesservice.SourcesService === "undefined" ? Object : _sourcesservice.SourcesService
    ])
], IntegrationsService);
